export default __webpack_public_path__ + "static/media/opinion6.1c9a70f7.jpg";